import { Tabs } from 'antd'
import { createStyles } from 'antd-style'

import { pick } from '@eastcoal/common/utils/object'

import { useContractDesignerStore } from '../Store/hooks/useStore'

import {
  RIGHT_PANEL_TAB_KEY_VARIABLE_CONFIGURE,
  RIGHT_PANEL_TAB_KEY_VARIABLE_LIST
} from './constants'
import { TemplateVariableConfigure } from './TemplateVariableConfigure'
import { TemplateVariableList } from './TemplateVariableList'

const useStyles = createStyles(({ token }) => ({
  container: {
    paddingInline: token.padding
  }
}))

const items = [
  {
    key: RIGHT_PANEL_TAB_KEY_VARIABLE_LIST,
    label: '参数库',

    children: <TemplateVariableList />
  },
  {
    key: RIGHT_PANEL_TAB_KEY_VARIABLE_CONFIGURE,
    label: '参数配置',
    children: <TemplateVariableConfigure />
  }
]

export const RightPanel = () => {
  const { rightPanelActiveKey, setRightPanelActiveKey } =
    useContractDesignerStore(state =>
      pick(state, ['rightPanelActiveKey', 'setRightPanelActiveKey'])
    )

  const { styles } = useStyles()

  return (
    <Tabs
      activeKey={rightPanelActiveKey}
      className={styles.container}
      items={items}
      onChange={setRightPanelActiveKey}
    />
  )
}
